<div class="header" [ngClass]="{ transparentBG: transparentBackground }">
  <div class="nav -container d-flex -border">
    <div class="nav -expand-button">
      @if (!smallMenuState) {
      <button-icon icon="hamburger" (click)="mobileToggleClick()"> </button-icon>
      } @if (smallMenuState) {
      <button-icon icon="close" (click)="mobileToggleClick()"> </button-icon>
      }
    </div>
    <div class="nav -logo-padding">
      <a [routerLink]="'/'">
        <div class="nav -logo">
          <site-logo [type]="'global'"></site-logo>
        </div>
      </a>
    </div>

    <div class="nav -wrapper">
      <div class="nav -menus d-flex">
        <app-main-nav (menuReady)="prepareSmallMenu($event)"></app-main-nav>
        <app-functional-nav
          (functionalNavReady)="prepareSmallFunctionalNav($event)"
          (accPullDown)="accountPullDownHandler($event)"
          [isToggle]="toggleAccountMenu"></app-functional-nav>
      </div>
    </div>
  </div>
  @if (metadata && metadata.template && (metadata.template === 'prod-doc-page' || metadata.template === 'product-landing' || metadata.template === 'app-product-landing' || metadata.template === 'contact-sales' || metadata.template === 'doc-page' || metadata.template === 'app-api-doc' || (metadata.template
  === 'redoc' && metadata['secondary-nav'] ) || (metadata.template === 'sdk' && metadata['secondary-nav'] )) &&
  (metadata['secondary-nav'] || metadata['sec-nav'])) {
  <div>
    <docheader-secondary-nav></docheader-secondary-nav>
  </div>
  }
</div>
<div #smallScreenMenuHolder>
  <small-screen-modal class="-menu-holder -small-screen" [ngClass]="smallMenuState ? '-open' : ''">
    <div class="-menu-wrapper">
      @if (functionalMenu && functionalMenu.length > 0) {
      <div class="-functional-nav">
        <div class="-solution-finder">
          <wpbutton to="/solution-finder" class="-secondary">Solution Finder</wpbutton>
        </div>
        <div class="-theme-icon">
          <a (click)="switchThemeMode()">
            @if ((theme == 'light')) {
            <icon name="moon" class="-theme -moon-dark"></icon>
            } @if ((theme == 'dark')) {
            <icon name="sun-medium" class="-theme -sun-light"></icon>
            }
          </a>
        </div>
        <a>
          <app-search-box [isSmall]="true"></app-search-box>
        </a>
      </div>
      } @if (menusNavigationState) {
      <div class="-menu-back" (click)="navigateMainMenu()">
        <button-icon
          icon="singlearrow-left"
          iconattributes="-sm15"
          iconhovercolor="-colorSupportingWhite"
          iconcolor="-colorSupportingWhite">
        </button-icon>
        Back
      </div>
      } @if (menusState) {
      <div class="-menus">
        @for (menuItem of mainMenu.right; track menuItem; let menuindex = $index) {
        <div class="-menu" [ngClass]="{ '-parent-menu-container': menuItem.children && menuItem.children.length > 0 }">
          @if (menuItem.children && menuItem.children.length > 0) {
          <h5>{{ menuItem.title }}</h5>
          } @if (!menuItem.children) { @if (!menuItem.external) {
          <a [routerLink]="menuItem.path">
            {{ menuItem.title }}
          </a>
          } @if (menuItem.external) {
          <a href="{{ menuItem.path }}" target="_blank" rel="noopener noreferrer">
            {{ menuItem.title }}
          </a>
          } } @if (menuItem.children && menuItem.children.length > 0 && menuItem.children[0].columnOne &&
          !menuItem.type) {
          <div class="-child-menus">
            @for (childMenuItem of menuItem.children; track childMenuItem; let childMenuIndex = $index) {
            <div class="-child-menu" (click)="showMenuContent(menuindex, childMenuIndex)">
              <span>{{ childMenuItem.title }}</span>
              @if (childMenuItem.columnOne || childMenuItem.columnThree || childMenuItem.columnTwo) {
              <button-icon name="arrow-right" iconattributes="-sm15"> </button-icon>
              }
            </div>
            }
          </div>
          } @if (menuItem.children && menuItem.children.length > 0 && menuItem.type) {
          <div class="-child-menus">
            @for (childMenuItem of menuItem.children; track childMenuItem; let childMenuIndex = $index) {
            <div class="-child-menu-tabs">
              <h5>{{ childMenuItem.title }}</h5>
              @if (childMenuItem.columnOne && childMenuItem?.columnOne?.length > 0) { @for (columnChild of
              childMenuItem.columnOne; track columnChild) {
              <div class="-child-menu">
                <app-link [to]="columnChild.path">{{ columnChild.title }}</app-link>
              </div>
              } }
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
      } @if (menusContentState) {
      <div class="-menu-content">
        <div class="-menu-head">
          <h5>{{ menuContent?.title }}</h5>
        </div>
        <div class="-menu-body">
          @if (menuContent?.columnOne && menuContent?.columnOne?.children && menuContent?.columnOne?.children?.length >
          0) {
          <ng-container *ngTemplateOutlet="column; context: { column: menuContent.columnOne }"></ng-container>
          } @if (menuContent?.columnTwo && menuContent?.columnTwo?.children && menuContent?.columnTwo?.children?.length
          > 0) {
          <ng-container *ngTemplateOutlet="column; context: { column: menuContent.columnTwo }"></ng-container>
          } @if (menuContent?.columnThree && menuContent?.columnThree?.children &&
          menuContent?.columnThree?.children?.length > 0) {
          <ng-container *ngTemplateOutlet="column; context: { column: menuContent.columnThree }"></ng-container>
          }
        </div>
      </div>
      }
    </div>
  </small-screen-modal>
</div>

<ng-template #column let-column="column">
  <div class="-menu-column">
    <h5>{{ column.title }}</h5>
    <div class="-menu-column-content">
      @for (childLinks of column?.children; track childLinks) { @for (link of childLinks.links; track link) {
      <div class="-menu-column-item">
        <app-link [to]="link.path" [externaloverride]="link.external">{{ link?.title }}</app-link>
        @if (link?.pdf) {
        <p class="-pdf">PDF</p>
        }
      </div>
      } }
    </div>
  </div>
</ng-template>
